export default __webpack_public_path__ + "static/persona-496b5a809be9fe2b1ae12624372f8968.jpg";